import { useMemo } from "react";

import { useMediaQuery } from "@/hooks";
import { SEM_MARCAS } from "@/modules/recursos/simulacao";

import { COMFORTABLE } from "../../gantt-fornecedor.utils";
import { ganttScaleOf, monthMinWidth } from "@/shared/components/gantt-carga/gantt-scale";
import { CARGA_FORNECEDOR_COMPACT_QUERY } from "@/shared/components/gantt-carga/mobile";
import type { GanttFornecedorProps, GanttFornecedorViewModel } from "./types-gantt-fornecedor";

export function useGanttFornecedor({
  rows,
  marcas = SEM_MARCAS,
  timeline,
  today,
  onConflictHover,
  onConflictLeave,
  onResolverConflito,
}: GanttFornecedorProps): GanttFornecedorViewModel {
  const isMobile = useMediaQuery(CARGA_FORNECEDOR_COMPACT_QUERY);
  const scale = useMemo(() => ganttScaleOf(timeline), [timeline]);

  return {
    rows,
    marcas,
    today,
    onConflictHover,
    onConflictLeave,
    onResolverConflito,
    scale,
    unitMinWidth: monthMinWidth(COMFORTABLE, isMobile),
  };
}
